import { CHECK_NPS_SUCCESS, SUBMIT_NPS_SUCCESS, DISMISS_NPS, NPS_ERROR } from '../actions/nps-rating';
import { USER_LOGOUT } from '../actions/types';

const initialState = {
  pending: false,
  partial: false,
  checkpoint: null,
  courseId: null,
  courseName: '',
  npsQuestion: '',
  followUps: [],
  existingScore: null,
  dismissed: false,
  submitted: false,
  error: false
};

export default function npsReducer(state = initialState, action) {
  switch (action.type) {
    case CHECK_NPS_SUCCESS:
      if (!action.payload.pending) {
        return { ...initialState };
      }
      return {
        ...state,
        pending: true,
        partial: action.payload.partial || false,
        checkpoint: action.payload.checkpoint,
        courseId: action.payload.course_id,
        courseName: action.payload.course_name,
        npsQuestion: action.payload.nps_question,
        followUps: action.payload.follow_ups || [],
        existingScore: action.payload.existing_score || null,
        dismissed: false,
        submitted: false,
        error: false
      };
    case SUBMIT_NPS_SUCCESS:
      return { ...initialState, submitted: true };
    case DISMISS_NPS:
      return { ...state, dismissed: true };
    case NPS_ERROR:
      return { ...state, error: true };
    case USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}
